export default "__VITE_ASSET__DG56WGkv__"